import { post } from './api';

export interface FeatureInfo {
  code: string;
  name: string;
  description: string;
}

export interface ClientFeature {
  code: string;
  name: string;
  description: string;
  enabled: boolean;
  expires_at: string | null;
  created_at: string | null;
  has_config?: boolean;
  config_value?: string;
}

export interface EnableFeatureRequest {
  feature_code: string;
  expires_at?: string | null;
}

export interface UpdateFeatureRequest {
  enabled?: boolean;
  expires_at?: string | null;
  config_value?: string;
}

export const featureService = {
  // 获取所有可用功能
  getAllFeatures: async (): Promise<FeatureInfo[]> => {
    const response = await post<FeatureInfo[]>('/api/admin/features/list');
    return response.data || [];
  },

  // 获取客户功能列表（管理员查询指定客户）
  getClientFeatures: async (clientId: number): Promise<ClientFeature[]> => {
    const response = await post<ClientFeature[]>('/api/admin/features/client', { client_id: clientId });
    return response.data || [];
  },

  // 获取当前用户的功能列表（客户查询自己）
  getMyFeatures: async (): Promise<ClientFeature[]> => {
    const response = await post<ClientFeature[]>('/api/features/my');
    return response.data || [];
  },

  // 为客户开通功能
  enableFeature: async (clientId: number, featureCode: string): Promise<void> => {
    await post('/api/admin/features/enable', { client_id: clientId, feature_code: featureCode });
  },

  // 更新功能
  updateFeature: async (clientId: number, featureCode: string, data: UpdateFeatureRequest): Promise<void> => {
    await post('/api/admin/features/update', { client_id: clientId, feature_code: featureCode, ...data });
  },

  // 关闭功能
  disableFeature: async (clientId: number, featureCode: string): Promise<void> => {
    await post('/api/admin/features/disable', { client_id: clientId, feature_code: featureCode });
  },
};

export default featureService;
